/**
 * General functions for working with Wordpress / Shopify content
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */

/**
 * Take a full-size image URL and generate a thumbnail size URL
 *
 * @param {string} url The full size image URL
 * @param {number} width The target width
 * @param {number} height The target height
 * @return string
 */
export function mutateImageUrl(url, width = 480, height = 480) {
    if (typeof url != 'string') {
        return '';
    }

    return url.substr(0, url.lastIndexOf('.')) + '_' + width + 'x' + height + url.substr(url.lastIndexOf('.'));
}

/**
 * Attempts to emulate Wordpress' "sanitize_title" functionality
 *
 * The data for certain form inputs is never passed with the JSON data so
 * it's up to the application to create the sanitized title itself from the
 * plain-text title which may be error prone as the Wordpress version can
 * be hooked into...
 *
 * @param {string} title
 * @param {number} maxLength The maximum length of the title to sanitise
 * @return string
 * @see https://gist.github.com/spyesx/561b1d65d4afb595f295
 * @see https://codex.wordpress.org/Function_Reference/sanitize_title
 */
export function sanitiseTitle(title, maxLength = 0) {
    let str = title.trim().toLowerCase();

    if (maxLength !== 0 && str.length > maxLength) {
        str = str.substr(0, maxLength).trim();
    }

    // remove accents, swap ñ for n, etc
    let from = 'àáäâèéëêìíïîòóöôùúüûñç',
        to = 'aaaaeeeeiiiioooouuuunc';

    for (let i = 0; i < str.length; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

export function convertFileToBase64(file) {
    if (!file) return;
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });
}
